import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faPlus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const CreditNoteVerificationModalTableActions = ({ data, exceptionsPatients, removePatientFromInvoice, addPatientFromInvoice }) => {

    useEffect(() => {
    }, []);

    return (<Fragment>
        <td role="cell">
            {
                exceptionsPatients.some(expPat => expPat.id_recibo == data.data.original.id_recibo) ?
                    <Tooltip title="Agregar paciente">
                        <IconButton style={{ fontSize: '15px' }} onClick={() => {
                            addPatientFromInvoice(data.data.original);
                        }}>
                            <FontAwesomeIcon icon={faPlus} />
                        </IconButton>
                    </Tooltip> : <Tooltip title="Retirar paciente">
                        <IconButton style={{ fontSize: '15px' }} onClick={() => {
                            removePatientFromInvoice(data.data.original);
                        }}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </IconButton>
                    </Tooltip>
            }
        </td>
    </Fragment>)
}

export default CreditNoteVerificationModalTableActions;